export const DEFAULT_DISPLAY_NAME = 'Your Cabinet Design';
const SERVER_DEFAULT_NAMES = ['Cabinet Project'];

const isServerDefaultName = (project) => {
  if (!project?.name) return true;
  if (project.name === `Project ${project.id}`) return true;
  return SERVER_DEFAULT_NAMES.includes(project.name);
};

export const getCurrentProject = (cabinetVisualizer) => {
  const projects = cabinetVisualizer?.projects;
  return projects?.[cabinetVisualizer?.currentProjectId] || null;
};

export const getDisplayNameForProject = (project) => {
  if (isServerDefaultName(project)) return DEFAULT_DISPLAY_NAME;
  return project.name;
};

export const getProjectDisplayName = (cabinetVisualizer) => {
  return getDisplayNameForProject(getCurrentProject(cabinetVisualizer));
};
